// extracted by mini-css-extract-plugin
module.exports =  {"textAreaComponent":"HAWBwPxmXd5vqVxdrqMY","label":"nk4sHQOGd9Cq0wvPvWwm","alternativeLabel":"pez2nlee3sNIIIgIWiQm"};